import {circInOut} from '../config/easing';
import {ISDESKTOP} from '../../constants/commonConstants';

export const fadeInOut = (level = 1) => {
    return {
        initial: {
            opacity: 0,
        },
        animate: {
            opacity: level,
            transition: {
                ...circInOut,
            },
        },
        exit: {
            opacity: 0,
            transition: {
                ...circInOut,
            },
        },
    };
};

export const clipPathCircle = (height = 0) => {
    const searchBarHeight = 50;
    const offsetWidth = 225;
    const minRadiusWidth = 650;
    const calculatedRadiusWidth = ((height + searchBarHeight) * 2) + offsetWidth;
    const finalRadiusWidth = calculatedRadiusWidth < minRadiusWidth ? minRadiusWidth : calculatedRadiusWidth;

    return {
        initial: {
            clipPath: ISDESKTOP ? 'circle(20px at 625px 25px)' : 'circle(20px at 95px 65px)',
        },
        animate: {
            clipPath: ISDESKTOP ?
                `circle(${finalRadiusWidth}px at 625px 25px)` :
                `circle(${height * 2 + offsetWidth}px at 95px 65px)`,
            transition: {
                ...circInOut,
            },
        },
        exit: {
            clipPath: ISDESKTOP ? 'circle(20px at 625px 25px)' : 'circle(20px at 95px 65px)',
            transition: {
                ...circInOut,
            },
        },
    };
};

export const slideInOut = {
    initial: {
        y: 20,
        opacity: 0,
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            ...circInOut,
        },
    },
    exit: {
        y: 20,
        opacity: 0,
        transition: {
            ...circInOut,
        },
    },
};

export const slideInOutHorizontal = {
    initial: {
        x: 50,
        opacity: 0,
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            ...circInOut,
        },
    },
    exit: {
        x: 50,
        opacity: 0,
        transition: {
            ...circInOut,
        },
    },
};

export const slideInOutRightToLeft = {
    initial: {
        x: 30,
        opacity: 0,
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            ...circInOut,
            delay: 0.05
        },
    },
    exit: {
        x: -30,
        opacity: 0,
        transition: {
            ...circInOut,
            delay: 0.05
        },
    },
};
